import { Component, OnInit } from '@angular/core';
import { Store } from '@ngrx/store';
import { SettingsPageComponent } from '../settings-page/settings-page.component';
import { PanelModule } from 'primeng/panel';
import { ButtonDirective } from 'primeng/button';
import { RouterLink } from '@angular/router';

@Component({
    selector: 'app-settings-profile',
    templateUrl: './settings-profile.component.html',
    styleUrls: ['./settings-profile.component.scss'],
    standalone: true,
    imports: [
        PanelModule,
        ButtonDirective,
        RouterLink,
    ],
})
export class SettingsProfileComponent extends SettingsPageComponent implements OnInit {
  constructor(store: Store) {
    super(store);
  }

  ngOnInit(): void {}
}
